import {
  computed,
  inject,
  onBeforeUnmount,
  onMounted,
  provide,
  ref,
} from 'vue';

const DASHBOARD_FULLSCREEN = Symbol('dashboard-fullscreen');

export const provideDashboardFullscreen = () => {
  const isExpanded = ref(false);
  const isBusy = ref(false);
  const nativeElement = () =>
    document.fullscreenElement || document.webkitFullscreenElement;
  const sync = () => {
    isExpanded.value = Boolean(nativeElement());
  };
  const toggle = async () => {
    if (isBusy.value) return;
    isBusy.value = true;
    try {
      if (isExpanded.value) {
        const exit = document.exitFullscreen || document.webkitExitFullscreen;
        if (nativeElement() && exit) {
          try {
            await exit.call(document);
          } catch {
            // Keep the exit control active if the browser refuses to leave.
          }
        }
        isExpanded.value = Boolean(nativeElement());
      } else {
        const root = document.documentElement;
        const enter = root.requestFullscreen || root.webkitRequestFullscreen;
        // Some iPad browsers expose the API but reject the request.
        isExpanded.value = true;
        if (enter) {
          try {
            await enter.call(root);
          } catch {
            // Retain the window expansion as an available fallback.
          }
        }
      }
    } finally {
      isBusy.value = false;
    }
  };
  const onKeydown = event => {
    if (event.key === 'Escape' && !nativeElement()) isExpanded.value = false;
  };
  onMounted(() => {
    document.addEventListener('fullscreenchange', sync);
    document.addEventListener('webkitfullscreenchange', sync);
    document.addEventListener('keydown', onKeydown);
  });
  onBeforeUnmount(() => {
    document.removeEventListener('fullscreenchange', sync);
    document.removeEventListener('webkitfullscreenchange', sync);
    document.removeEventListener('keydown', onKeydown);
  });
  const state = {
    isExpanded,
    isBusy,
    toggle,
    label: computed(() =>
      isExpanded.value ? 'Sair da tela cheia' : 'Tela cheia'
    ),
  };
  provide(DASHBOARD_FULLSCREEN, state);
  return state;
};

export const useDashboardFullscreen = () => inject(DASHBOARD_FULLSCREEN, null);
